const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path fill-rule="evenodd" d="M11 2.25a8.75 8.75 0 1 0 5.634 15.445l3.336 3.335a.75.75 0 1 0 1.06-1.06l-3.335-3.336A8.75 8.75 0 0 0 11 2.25M3.75 11a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0" clip-rule="evenodd"/></svg>';
export {
  e as w
};
